import { Dialog, DialogDismiss, DialogHeading } from '@ariakit/react';
import { AnimatePresence, motion } from 'motion/react';

import { ClubCollections } from '@data';
import { Box, CircularCloseIcon, Spinner, typography } from '@ui';

import { CompactClubTable } from '../CompactClubTable';

import * as css from './ClubTableModal.css';

type ClubTableModalProps = {
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
    onClubClick: (clubId: number) => void;
    selectedClub?: number;
    canSelectClubGroup?: boolean;
    selectedClubGroup?: string;
    onClubGroupClick?: (clubGroupName: string, clubTypeId: number) => void;
    noClubSelected?: boolean;
    onNoClubClick?: () => void;
    clubs?: ClubCollections;
};

export function ClubTableModal({
    modalOpen,
    setModalOpen,
    onClubClick,
    selectedClub,
    canSelectClubGroup = false,
    selectedClubGroup,
    onClubGroupClick,
    noClubSelected = false,
    onNoClubClick,
    clubs,
}: ClubTableModalProps) {
    return (
        <AnimatePresence>
            {modalOpen && (
                <Dialog
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    className={css.modal}
                    backdrop={
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            style={{
                                backgroundColor: 'rgb(0,0,0,0.3)',
                            }}
                        />
                    }
                    render={
                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                        />
                    }
                >
                    <div className={css.modalHeader}>
                        <Box>
                            <DialogHeading
                                className={typography({
                                    variant: 'h3',
                                    weight: 'bold',
                                })}
                            >
                                Filter by club
                            </DialogHeading>
                            {canSelectClubGroup && (
                                <p
                                    className={typography({
                                        variant: 'pSmall',
                                        color: 'muted',
                                    })}
                                >
                                    Select a club group to target every club in that group.
                                </p>
                            )}
                        </Box>
                        <DialogDismiss>
                            <CircularCloseIcon width={24} />
                        </DialogDismiss>
                    </div>

                    {!clubs ? (
                        <Spinner size="l" />
                    ) : (
                        <Box style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <CompactClubTable
                                clubCollections={clubs}
                                onClick={onClubClick}
                                displaySelectedClubIds={selectedClubGroup ? [] : selectedClub ? [selectedClub] : []}
                                canSelectClubGroup={canSelectClubGroup}
                                selectedClubGroup={selectedClubGroup}
                                onClubGroupClick={onClubGroupClick}
                                noClubSelected={noClubSelected}
                                onNoClubClick={onNoClubClick}
                            />
                        </Box>
                    )}
                </Dialog>
            )}
        </AnimatePresence>
    );
}
